// Retain this path for Network callers while sharing the recovery behavior
// with the other operator-facing detail pages.
var pageRequestState = require('../layout/components/pageRequestState');

module.exports = {
  initialize: pageRequestState.initialize,
  run: function (ctrl, request) {
    return pageRequestState.run(ctrl, request, {
      errorMessage: 'Unable to load Network data:'
    });
  },
  view: pageRequestState.view,
  _test: pageRequestState._test
};
